import { CompassUserContext } from '@orientaction/Context';
import { useCompassMenu } from '@orientaction/hooks';
import { userService } from '@orientaction/services';
import {
  getCompassTestVisibility,
  NEEDS_TEST_SERVICE_IDS,
  userHasAnyService,
} from '@orientaction/utils';
import { useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

export const useCompassPage = () => {
  const { year }: any = useParams();
  const { userInfos } = useContext<any>(CompassUserContext);
  const { getMyData, loading, harmonyTestLastResult, user, token } = useCompassMenu();
  const getMyDataRef = useRef(getMyData);
  const userRef = useRef(user);

  useEffect(() => {
    getMyDataRef.current = getMyData;
    userRef.current = user;
  }, [getMyData, user]);

  useEffect(() => {
    if (year && token) {
      const getMe = async () => {
        const { data: userData } = await userService.getMe(token, year);
        localStorage.setItem(
          'userInfos',
          JSON.stringify({
            ...userRef.current,
            upper_hierarchy: userData.upper_hierarchy,
            rattachement: userData.rattachement,
            company_user_role: userData.company_user_role,
            service: userData.service,
            services: userData.services,
            allowed_services: userData.allowed_services,
          }),
        );
      };

      getMe();
      window.scrollTo(0, 0);
    }
  }, [token, year]);

  useEffect(() => {
    if (year && token && !Number.isNaN(Number(year))) {
      getMyDataRef.current();
    }
  }, [token, year]);

  const isNonRattachedBeneficiary = !userInfos?.rattachement;
  const canAccessNeeds =
    userHasAnyService(userInfos, NEEDS_TEST_SERVICE_IDS) || isNonRattachedBeneficiary;

  const { showNeeds, showNeedsPro } = getCompassTestVisibility(userInfos);

  return {
    loading,
    harmonyTestLastResult,
    canAccessNeeds,
    showNeeds,
    showNeedsPro,
  };
};
